<template>
  <div class="px-5">
    <div class="d-flex justify-space-between align-center mb-4">
      <h1>Procesamiento de Archivos | Base Marcación</h1>
      
      <!-- Execution Button with Menu -->
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            v-bind="attrs"
            v-on="on"
            :loading="ejecutandoProceso"
            :disabled="ejecutandoProceso"
          >
            <v-icon left>mdi-play-circle</v-icon>
            Ejecutar proceso
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        
        <v-list>
          <v-list-item @click="ejecutarProceso('marcacion')">
            <v-list-item-avatar>
              <v-icon color="primary">mdi-tag</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Marcación</v-list-item-title>
              <v-list-item-subtitle>Procesar archivos de marcación</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          
          <!-- <v-list-item @click="ejecutarProceso('cobranza')" disabled>
            <v-list-item-avatar>
              <v-icon color="grey">mdi-currency-usd</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Cobranza</v-list-item-title>
              <v-list-item-subtitle>Próximamente disponible</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item @click="ejecutarProceso('otros')" disabled>
            <v-list-item-avatar>
              <v-icon color="grey">mdi-cog</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Otros</v-list-item-title>
              <v-list-item-subtitle>Próximamente disponible</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </div>
    
    <div class="my-5">
      <filtros-procesamientos 
        ref="filtros"
        @buscar="buscarProcesamientos"
        @limpiar="limpiarResultados"
      />
    </div>
    <div class="my-5">
      <errores-procesamientos 
        :errores="errores"
        :loading="loadingErrores"
      />
    </div>
    <div>
      <resultados-procesamiento 
        ref="resultados"
        :procesamientos="procesamientos"
        :loading="loading"
      />
    </div>

    <!-- Confirmation Dialog -->
    <v-dialog v-model="dialogConfirmacion" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline d-flex justify-space-between align-center" style="color: #cc092f;">
          <span>
            <v-icon left color="#cc092f">mdi-play-circle</v-icon>
            Ejecutar {{ tipoProcesoSeleccionado }}
          </span>
          <v-btn 
            icon 
            @click="cancelarEjecucion"
            :disabled="ejecutandoProceso"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text>
          <div class="text-body-1 mb-4">
            Seleccione la fecha base para ejecutar el procesamiento de <strong>{{ tipoProcesoSeleccionado }}</strong>:
          </div>
          
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="fechaEjecucion"
                label="Fecha Base"
                type="date"
                outlined
                dense
                required
                prepend-inner-icon="mdi-calendar"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card-actions class="justify-center pb-6">
          <v-btn 
            color="#cc092f"
            dark
            rounded
            large
            @click="confirmarEjecucion"
            :loading="ejecutandoProceso"
            :disabled="ejecutandoProceso || !fechaEjecucion"
          >
            <v-icon left>mdi-play-circle</v-icon>
            Ejecutar Procesamiento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Date Range Dialog Component -->
    <DateRangeDialog
      :visible="dialogBase"
      :accion="accionBase"
      :loading="ejecutandoAccionBase"
      :total-records="totalRecordsCount"
      :loading-records="loadingRecordsCount"
      :initial-date="selectedBaseMes"
      @confirm="confirmarAccionBase"
      @cancel="cancelarAccionBase"
      @date-change="onDateRangeChange"
    />
  </div>
</template>

<script>
import FiltrosProcesamientos from "./filtrosProcesamientos.vue";
import ResultadosProcesamiento from "./resultadosProcesamiento.vue";
import ErroresProcesamientos from "./erroresProcesamientos.vue";
import DateRangeDialog from "@/components/commondComponents/DateRangeDialog.vue";
import { findProcesamientos, getProcesamientoErrores, ejecutarProcesamientoMarcacion, activarBase, desactivarBase, getLeadsFiltros } from "@/services/procesamientoArchivosService";

export default {
  components: {
    FiltrosProcesamientos,
    ResultadosProcesamiento,
    ErroresProcesamientos,
    DateRangeDialog,
  },

  data() {
    return {
      procesamientos: [],
      loading: false,
      errores: [],
      loadingErrores: false,
      ejecutandoProceso: false,
      dialogConfirmacion: false,
      tipoProcesoSeleccionado: '',
      fechaEjecucion: null,
      // Base actions data
      dialogBase: false,
      accionBase: '',
      ejecutandoAccionBase: false,
      totalRecordsCount: null,
      loadingRecordsCount: false,
      selectedBaseMes: null,
      rules: {
        required: value => !!value || 'Este campo es requerido'
      }
    };
  },

  methods: {
    async buscarProcesamientos(filtros) {
      try {
        this.loading = true;
        
        // Check if it's a base action
        if (filtros.tipo_proceso === 'Activar Base' || filtros.tipo_proceso === 'Desactivar Base') {
          await this.handleBaseAction(filtros);
          return;
        }
        
        // Limpiar filtros vacíos para búsquedas regulares
        const filtrosLimpios = {};
        if (filtros.tipo_proceso) filtrosLimpios.tipo_proceso = filtros.tipo_proceso;
        if (filtros.base_mes) filtrosLimpios.base_mes = filtros.base_mes;

        const response = await findProcesamientos(filtrosLimpios);
        
        if (response.success) {
          this.procesamientos = response.data.procesamientos || [];
          this.$toast.success(response.message || 'Búsqueda exitosa');
          
          // Fetch errors for all procesamientos
          await this.buscarErroresProcesamientos(this.procesamientos);
          
          // Show results dialog after getting data
          if (this.$refs.resultados) {
            this.$refs.resultados.mostrarResultados();
          }
        } else {
          this.$toast.error(response.message || 'Error al buscar procesamientos');
          this.procesamientos = [];
        }
      } catch (error) {
        console.error('Error al buscar procesamientos:', error);
        this.$toast.error(error.message || 'Error inesperado al buscar procesamientos');
        this.procesamientos = [];
      } finally {
        this.loading = false;
        if (this.$refs.filtros) {
          this.$refs.filtros.setLoading(false);
        }
      }
    },

    limpiarResultados() {
      this.procesamientos = [];
      this.errores = [];
    },

    async handleBaseAction(filtros) {
      // Validate that base_mes is provided for base actions
      if (!filtros.base_mes) {
        this.$toast.error('Debe seleccionar una fecha para las acciones de base');
        this.loading = false;
        if (this.$refs.filtros) {
          this.$refs.filtros.setLoading(false);
        }
        return;
      }

      // Determine action type
      const accion = filtros.tipo_proceso === 'Activar Base' ? 'activar' : 'desactivar';
      
      // Set the date and action
      this.selectedBaseMes = filtros.base_mes;
      this.accionBase = accion;
      
      // Fetch record count immediately
      try {
        this.loadingRecordsCount = true;
        this.totalRecordsCount = null;
        
        // Determine ciclo_finalizado based on action
        let cicloFinalizado = null;
        if (accion === 'activar') {
          cicloFinalizado = 1; // For "Activar base"
        } else if (accion === 'desactivar') {
          cicloFinalizado = 0; // For "Desactivar base"
        }
        
        // Call API for the selected date with ciclo_finalizado filter
        const response = await getLeadsFiltros(filtros.base_mes, cicloFinalizado);
        
        if (response && response.numRegisters) {
          this.totalRecordsCount = response.numRegisters;
        } else {
          this.totalRecordsCount = 0;
        }
        
        // Show dialog after getting the count
        // Add a small delay to ensure loading state is visible
        setTimeout(() => {
          this.dialogBase = true;
        }, 100);
        
      } catch (error) {
        console.error(`Error getting records for base action ${accion}:`, error);
        this.$toast.error('Sin leads registrados en la fecha seleccionada');
        this.totalRecordsCount = null;
      } finally {
        this.loadingRecordsCount = false;
        // Reset loading state after dialog is shown or error occurred
        setTimeout(() => {
          this.loading = false;
          if (this.$refs.filtros) {
            this.$refs.filtros.setLoading(false);
          }
        }, 150);
      }
    },

    async buscarErroresProcesamientos(procesamientos) {
      if (!procesamientos || procesamientos.length === 0) {
        this.errores = [];
        return;
      }

      try {
        this.loadingErrores = true;
        const todosLosErrores = [];

        // Fetch errors for each procesamiento
        for (const procesamiento of procesamientos) {
          try {
            const errorResponse = await getProcesamientoErrores(procesamiento.id);
            if (errorResponse.success && errorResponse.data.errores) {
              todosLosErrores.push(...errorResponse.data.errores);
            }
          } catch (error) {
            console.error(`Error al obtener errores para procesamiento ${procesamiento.id}:`, error);
            // Continue with other procesamientos even if one fails
          }
        }

        this.errores = todosLosErrores;
      } catch (error) {
        console.error('Error al buscar errores de procesamientos:', error);
        this.$toast.error('Error al obtener los errores de procesamiento');
        this.errores = [];
      } finally {
        this.loadingErrores = false;
      }
    },

    ejecutarProceso(tipoProceso) {
      if (tipoProceso !== 'marcacion') {
        this.$toast.info('Esta funcionalidad estará disponible próximamente');
        return;
      }

      // Set default date to today
      const today = new Date().toISOString().split('T')[0];
      this.fechaEjecucion = today;
      
      // Show confirmation dialog
      this.tipoProcesoSeleccionado = 'Marcación';
      this.dialogConfirmacion = true;
    },

    cancelarEjecucion() {
      this.dialogConfirmacion = false;
      this.tipoProcesoSeleccionado = '';
      this.fechaEjecucion = null;
    },

    async confirmarEjecucion() {
      if (!this.fechaEjecucion) {
        this.$toast.error('Debe seleccionar una fecha base para la ejecución');
        return;
      }

      try {
        this.ejecutandoProceso = true;
        const response = await ejecutarProcesamientoMarcacion(this.fechaEjecucion);
        
        if (response.success) {
          this.$toast.success(response.message || 'Procesamiento ejecutado exitosamente');
          this.dialogConfirmacion = false;
          this.fechaEjecucion = null;
          
          // Optionally refresh the search results after successful execution
          // You can uncomment the following lines if you want to auto-refresh
          // if (this.$refs.filtros && this.$refs.filtros.filtros) {
          //   await this.buscarProcesamientos(this.$refs.filtros.filtros);
          // }
        } else {
          this.$toast.error(response.message || 'Error al ejecutar el procesamiento');
        }
      } catch (error) {
        console.error('Error al ejecutar procesamiento:', error);
        this.$toast.error(error.message || 'Error inesperado al ejecutar el procesamiento');
      } finally {
        this.ejecutandoProceso = false;
        this.tipoProcesoSeleccionado = '';
      }
    },

    // Base actions methods
    async onDateRangeChange(dateData) {
      const { fechaInicio } = dateData;
      
      if (!fechaInicio) {
        this.totalRecordsCount = null;
        return;
      }

      try {
        this.loadingRecordsCount = true;
        this.totalRecordsCount = null;
        
        // Determine ciclo_finalizado based on action
        let cicloFinalizado = null;
        if (this.accionBase === 'activar') {
          cicloFinalizado = 1; // For "Activar base"
        } else if (this.accionBase === 'desactivar') {
          cicloFinalizado = 0; // For "Desactivar base"
        }
        
        // Call API for the selected date with ciclo_finalizado filter
        const response = await getLeadsFiltros(fechaInicio, cicloFinalizado);
        
        if (response && response.numRegisters) {
          this.totalRecordsCount = response.numRegisters;
        } else {
          this.totalRecordsCount = 0;
        }
      } catch (error) {
        console.error(`Error getting records for date ${fechaInicio}:`, error);
        this.totalRecordsCount = null;
      } finally {
        this.loadingRecordsCount = false;
      }
    },

    cancelarAccionBase() {
      this.dialogBase = false;
      this.accionBase = '';
      this.selectedBaseMes = null;
      this.totalRecordsCount = null;
      this.loadingRecordsCount = false;
    },

    async confirmarAccionBase(eventData) {
      const { fechas } = eventData;
      
      if (!fechas || fechas.length === 0) {
        this.$toast.error('Por favor selecciona las fechas requeridas');
        return;
      }

      try {
        this.ejecutandoAccionBase = true;

        let response;
        if (this.accionBase === 'activar') {
          response = await activarBase(fechas);
        } else {
          response = await desactivarBase(fechas);
        }
        
        if (response.success) {
          this.$toast.success(response.message || `Base ${this.accionBase === 'activar' ? 'activada' : 'desactivada'} exitosamente`);
          this.dialogBase = false;
        } else {
          this.$toast.error(response.message || `Error al ${this.accionBase} la base`);
        }
      } catch (error) {
        console.error(`Error al ${this.accionBase} base:`, error);
        this.$toast.error(error.message || `Error inesperado al ${this.accionBase} la base`);
      } finally {
        this.ejecutandoAccionBase = false;
        this.accionBase = '';
      }
    }
  }
};
</script>
